import React from "react";
import { useHistory, useParams } from "react-router-dom";
import "../../user/pages/dashboard/dashboard.css";

const StatsDetails = () => {

  const { stats } = useParams();


  return (
    <div className="mainContent">
        <h1 style={{color: 'white'}}>Stats Details for for {stats}</h1>
      
    </div>
  );
};

export default StatsDetails;
